import { createContext, useContext } from 'react'

export interface CustomerBox {
    id: string
}

export interface CustomerInfo {
    boxes: CustomerBox[]
    api_token: string
}

interface CustomerContextType {
    customer: CustomerInfo | null
    setCustomer: (c: CustomerInfo | null) => void
    deleteCustomerSession: () => Promise<void>
    isLoaded: boolean

    password: string | null
    setPassword: (v: string | null) => void
}

export const CustomerContext = createContext<CustomerContextType | undefined>(
    undefined,
)

export const useCustomer = () => {
    const ctx = useContext(CustomerContext)
    if (!ctx)
        throw new Error('useCustomer must be used inside CustomerProvider')

    return ctx
}
